<template>
    <div>
            <div class="panel ">
 

                <div class="panel-heading">
                    <nav class="level is-mobile">
                        <div class="level-left">
                            <div class="level-item">
                                Recent Images Nonautomate Lab
                            </div>

                        </div>
                        <div class="level-right">

                            <div class="level-item">
                                <b-tooltip label="Reload/Renew All Recent">
                                <b-button type="is-primary  is-light" outlined
                                          icon-right="refresh" @click="refreshImageNonRecently"/>
                                </b-tooltip>
                            </div>
                        </div>
                    </nav>
                </div>
                <div class="">
 



   
            <b-tabs v-model="activeTabViewImagesModel">
                    <b-tab-item label="View As Images Series">
                        <ImagesLABNonRecently_ViewImagesSeries 
                          @showLab="showLab"
                          @loadMoreDataImagesRecently="loadDataMore" />
                    </b-tab-item>
                    <b-tab-item label="View As LAB ID">
                        <ImagesLABNonRecently_ViewGrpIDLab 
                           @showLab="showLab"
                           @loadMoreDataImagesRecently="loadDataMore" />
                    </b-tab-item>
            </b-tabs>        
 
            

             

        
                </div>
            </div>
    </div>
</template>


<script>
import { mapActions , mapMutations, mapState } from "vuex";
import ImagesLABNonRecently_ViewGrpIDLab from './ImagesLABNonRecently_ViewGrpIDLab.vue'
import ImagesLABNonRecently_ViewImagesSeries from './ImagesLABNonRecently_ViewImagesSeries.vue'



export default {
    name : "ImagesLABNonRecently",
 
    components:{
      ImagesLABNonRecently_ViewGrpIDLab,
      ImagesLABNonRecently_ViewImagesSeries,
    },
    computed:{
        ...mapState({
            imagesArrRecently : state => state.home.imagesArrRecently ,
            firstImagesArrRecently : state => state.home.firstImagesArrRecently ,
            skipImagesArrRecently : state => state.home.skipImagesArrRecently ,

            activeTabViewImages: state => state.home.activeTabViewImages ,
            isMoreBtnLoading : state => state.home.isMoreBtnLoading ,
        }),
        activeTabViewImagesModel:{
                get: function () {
                    return this.activeTabViewImages
                },
                set: function (newValue) {
                    this.setActiveTabViewImages(newValue)
                }
        },
        isMoreBtnLoadingModel:{
                get: function () {
                    return this.isMoreBtnLoading
                },
                set: function (newValue) {
                    this.setIsMoreBtnLoading(newValue)
                }
        },
    },    
    methods:{
         ...mapMutations({
            setClearImagesArrRecently : 'home/setClearImagesArrRecently',
            setFirstImagesArrRecently : 'home/setFirstImagesArrRecently',
            setSkipImagesArrRecently : 'home/setSkipImagesArrRecently',
            setActiveTabViewImages: 'home/setActiveTabViewImages',
            setIsMoreBtnLoading : 'home/setIsMoreBtnLoading',
        }),
         ...mapActions({
            fetchImagesRecently : 'home/fetchImagesRecently',
        }),


        refreshImageNonRecently(){
            this.setClearImagesArrRecently()
            this.setFirstImagesArrRecently(10)
            this.setSkipImagesArrRecently(0)
            this.fetchImagesRecently()  
        },
     
        loadDataMore(){
            this.setSkipImagesArrRecently( this.skipImagesArrRecently + this.firstImagesArrRecently) 
            this.fetchImagesRecently()
                .then(()=>{
                   this.isMoreBtnLoadingModel = false
                })
        },
        showLab(payload){
            this.$emit('showLab',payload)
        }

         
    },
    data(){
        return{
            perPage : 10,
            currentPage : 1,
         //   activeTabViewImages : 0,
        }
    }
}
</script>


<style scoped>
    img{
        cursor: pointer;
        width:100%;
        height:100%;
        object-fit: contain;

    }
    /*.card{*/
    /*    border: 5px solid #555;*/
    /*}*/



</style>